import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, PopoverController, ToastController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { CommonService } from 'src/providers/common';
import { ServicesProvider, } from 'src/providers/services';


@Component({
  selector: 'app-modpricetag',
  templateUrl: './modpricetag.page.html',
  styleUrls: ['./modpricetag.page.scss'],
})
export class ModpricetagPage implements OnInit {
  dealDet = [];
  servOff = [];
  labDet = [];
  from: any;
  fromdate: any;
  dealdetails: any;
  address: any;
  editaccess: boolean = true;
  dealamountlab: any = [true];
  HOC: any;
  storeOfferCards: any;
  storeOfferCards1: any;
  trainerId: any;
  trainingId: any;
  CommonDates: any = [];
  validatefor: any;
  totalPackagesArray: any = [];
  noResultFound: boolean;
  reportdata:any;
  constructor(
    public viewCtrl: PopoverController,
    public addCall: AddCall,
    public Common: CommonService,
    public service: ServicesProvider,
    public loadingController: LoadingController,
    public router: Router,
    public toastController: ToastController,
  ) { }

  ngOnInit() {
    this.initial();
  }

  ionViewWillEnter() {
    this.editaccess = true;
    this.Common.address = this.address;
    this.initial();
  }
  editAddress() {
    this.viewCtrl.dismiss(true);
  }

  editdadd() {
    this.Common.address = this.address;
  }

  editdaddnurse() {
    this.Common.address = this.address;
  }


  initial() {
    if (this.from == 'Doctor') {
      this.dealDet = JSON.parse(window.localStorage['dealDetl']).dealsDetails;
      console.log(JSON.parse(window.localStorage['dealDetl']));

      let i = 0;
      for (let item of this.dealDet) {
        let dOpt = item.deal_options;
        if (dOpt == 'Amount') {
          this.servOff.push(item.deal_amount + ' ');
        } else if (dOpt == 'Percentage') {
          this.servOff.push(item.deal_amount + ' ');
        } else {
          this.servOff.push('');
        }
        i++;
      }
    } else if (this.from == 'Lab') {
      for (const [index, item] of this.labDet.entries()) {
        let val = 0;
        val = this.totalAmt(item);
        val = Number(val.toFixed(2));
        this.labDet[index] = { ...this.labDet[index], labTotalcost: val, dealamountlab: this.dealamountlab };
      }
    } else if (this.from == 'lab') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_options == 'Amount') {
          this.servOff.push(item.deal_amount + ' ');
        } else if (item.deal_options == 'Percentage') {
          this.servOff.push(item.deal_amount + ' ');
        } else {
          this.servOff.push('');
        }
        i++;
      }
    } else if (this.from == 'physiotherapy') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_options == 'Amount') {
          this.servOff.push(item.deal_amount + ' ');
        } else if (item.deal_options == 'Percentage') {
          this.servOff.push(item.deal_amount + ' ');
        } else {
          this.servOff.push('');
        }
        i++;
      }
    } else if (this.from == 'trainer') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_options == 'Amount') {
          this.servOff.push(item.deal_amount + ' ' + this.addCall.title61);
        } else if (item.deal_options == 'Percentage') {
          this.servOff.push(item.deal_amount + ' ' + this.addCall.title60);
        } else {
          this.servOff.push('');
        }
        i++;
      }
    } else if (this.from == 'room') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_options == 'Amount') {
          this.servOff.push(item.deal_amount + ' ' + this.addCall.title61);
        } else if (item.deal_options == 'Percentage') {
          this.servOff.push(item.deal_amount + ' ' + this.addCall.title60);
        } else {
          this.servOff.push('');
        }
        i++;
      }
    }  
    else if (this.from == 'diet') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_option == 'Amount') {
          const formattedValue = Number(item.deal_value).toFixed(3);
       this.servOff.push(formattedValue + ' ' + (this.addCall.selectedLanguage == 'ea' ? (this.addCall.title92 + " "+this.addCall.title650+" " ) : this.addCall.title61));
      }
      else if (item.deal_option == 'Percentage') {
        let formattedValue;
        if (Number(item.deal_value) % 1 !== 0) {
            formattedValue = Number(item.deal_value).toFixed(3);
        } else {
            formattedValue = item.deal_value;
        }
    
        this.servOff.push(formattedValue + ' ' + (this.addCall.selectedLanguage == 'ea' ? ("%" + this.addCall.title650+" " ) : this.addCall.title60));
    }
         else {
          this.servOff.push('');
        }
        i++;
      }
    }else if (this.from == 'traineronly') {
      let i = 0;
      for (let item of this.dealdetails) {
        if (item.deal_options == 'Amount') {
          this.servOff.push(item.deal_amount);
        } else if (item.deal_options == 'Percentage') {
          this.servOff.push(item.deal_amount);
        } else {
          this.servOff.push('');
        }
        i++;
      }
    }
  }

  dismiss(id) {
    this.viewCtrl.dismiss({
      doctorId: JSON.parse(window.localStorage['dealDetl']).doctorId,
      clinicId: JSON.parse(window.localStorage['dealDetl']).clinicId,
      availDate: JSON.parse(window.localStorage['dealDetl'])
        .SlotAvailabilityDate,
      dealId: id,
      docName: JSON.parse(window.localStorage['dealDetl']).vendor_name,
    });
  }

  dismissforphysio(id, index) {
    this.viewCtrl.dismiss({
      dataforphysio: this.dealdetails[index],
    });
  }

  trainerdismiss(data, index) {
    this.trainerId = data.deal_vendor_id
    this.trainingId = data.tr_tainingcategory_id
    if (data.tr_training_mode == "1") {
      this.HOC = 'homeList';
      this.chsOffHiglight(this.HOC, data.deal_service_type_id);
    } else if (data.tr_training_mode == "2") {
      this.HOC = 'onlineList';
      this.chsOffHiglight(this.HOC, data.deal_service_type_id);
    } else if (data.tr_training_mode == "3") {
      this.HOC = 'centerList';
      this.chsOffHiglight(this.HOC, data.deal_service_type_id);
    } else {
      this.HOC = 'homeList';
      this.chsOffHiglight(this.HOC, data.deal_service_type_id);
    }
  }

  dismissfortrainer(id, index) {
    this.viewCtrl.dismiss({
      datafortrainer: this.dealdetails[index],
    });
  }
  dismissfordiet(id,value,item, index) {
    this.viewCtrl.dismiss({
      datafortrainer: this.dealdetails[index],
    });
  }
  
  dismiss_report() {
    this.viewCtrl.dismiss();
  }

  totalAmt(item: any) {

    let dealPrice = 0;
    this.dealamountlab = true;
    const fromDate = new Date(this.fromdate);

    if (item.dealsDetails.length > 0) {

      const dealValidFrom = new Date(item.dealsDetails[0].deal_valid_from);
      const dealValidTo = new Date(item.dealsDetails[0].deal_valid_to);

      // Extracting only the date part from the dates
      const fromDateWithoutTime = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
      const dealValidFromWithoutTime = new Date(dealValidFrom.getFullYear(), dealValidFrom.getMonth(), dealValidFrom.getDate());
      const dealValidToWithoutTime = new Date(dealValidTo.getFullYear(), dealValidTo.getMonth(), dealValidTo.getDate());

      // Perform the comparison
      if (dealValidFromWithoutTime <= fromDateWithoutTime && fromDateWithoutTime <= dealValidToWithoutTime) {
        this.dealamountlab = true;
        if (item.dealsDetails[0].deal_options == 'Percentage') dealPrice = (Number(item.cost) * Number(item.dealsDetails[0].deal_amount)) / 100;
        else if (item.dealsDetails[0].deal_options == 'Amount') dealPrice = Number(item.dealsDetails[0].deal_amount);
        return Number(item.cost) - Number(dealPrice);;
      } else {
        this.dealamountlab = false;
       return Number(item.cost)
      }

    } else {
      this.dealamountlab = false;
      return Number(item.cost);
    }
  }

  totalAmt1(item) {
    return Number(item.test_amount);
  }

  async chsOffHiglight(value, tr_package_id) {

    this.HOC = value;
    let getDate = new Date();

    var currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    if (value == 'homeList') {
      try {
        this.storeOfferCards = [];
        this.storeOfferCards1 = [];

        this.HOC = value;
        var obj = {
          "trainerId": this.trainerId,
          "trainingId": this.trainingId,
          "currentDate": currentDate,
          "patientId": localStorage.getItem("patient_id"),
          "trainingMode": "1"
        }
        this.noResultFound = false;
        const loading = await this.loadingController.create({
          cssClass: 'my-custom-class',
          message: 'Please wait...'
        });
        await loading.present();
        this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
          await loading.dismiss();
          this.storeOfferCards = res.data;
          const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
            .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));
          this.storeOfferCards1 = uniqueDataArray;
          this.storeOfferCards1.length > 0 ? this.noResultFound = false : this.noResultFound = true;
          const filteredData = this.storeOfferCards1.filter(item => item.tr_package_id == tr_package_id);
          this.packagedet(filteredData[0], this.HOC)
        });
      }
      catch (error) {
        console.log(error);
        this.showToast();
        this.router.navigate(['../tabs/home']);
      }

    } else if (value == 'onlineList') {
      try {
        this.storeOfferCards = [];
        this.storeOfferCards1 = [];
        this.HOC = value;
        this.noResultFound = false;
        const loading = await this.loadingController.create({
          cssClass: 'my-custom-class',
          message: 'Please wait...'
        });

        await loading.present();
        this.HOC = value;
        var obj = {
          "trainerId": this.trainerId,
          "trainingId": this.trainingId,
          "currentDate": currentDate,
          "patientId": localStorage.getItem("patient_id"),
          "trainingMode": "2"
        }
        this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
          await loading.dismiss();
          this.storeOfferCards = res.data;
          const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
            .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));

          this.storeOfferCards1 = uniqueDataArray;
          this.storeOfferCards1.length > 0 ? this.noResultFound = false : this.noResultFound = true;
          const filteredData = this.storeOfferCards1.filter(item => item.tr_package_id == tr_package_id);
          this.packagedet(filteredData[0], this.HOC)
        })
      }
      catch (error) {
        this.showToast();
        console.log(error);
        this.router.navigate(['../tabs/home']);
      }
    } else if (value == 'centerList') {

      try {
        this.storeOfferCards = [];
        this.storeOfferCards1 = [];
        this.HOC = value;
        this.noResultFound = false;
        const loading = await this.loadingController.create({
          cssClass: 'my-custom-class',
          message: 'Please wait...'
        });
        var obj = {
          "trainerId": this.trainerId,
          "trainingId": this.trainingId,
          "currentDate": currentDate,
          "patientId": localStorage.getItem("patient_id"),
          "trainingMode": "3"
        }
        await loading.present();
        this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
          await loading.dismiss();
          this.storeOfferCards = res.data;
          const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
            .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));
          this.storeOfferCards1 = uniqueDataArray;
          this.storeOfferCards1.length > 0 ? this.noResultFound = false : this.noResultFound = true;
          const filteredData = this.storeOfferCards1.filter(item => item.tr_package_id == tr_package_id);
          this.packagedet(filteredData[0], this.HOC)
        })
      }
      catch (error) {
        this.showToast();
        console.log(error);
        this.router.navigate(['../tabs/home']);
      }
    }

  }


  packagedet(tr_pack, HOC) {
    try {
      this.totalPackagesArray = [];
      if (tr_pack.tr_training_mode == '1') {
        for (let i = 0; i <= this.storeOfferCards.length; i++) {
          if (this.storeOfferCards[i] != undefined) {
            if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
              this.totalPackagesArray.push(this.storeOfferCards[i])
            }
          }
        }
        this.homeApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
      } else if (tr_pack.tr_training_mode == '2') {
        for (let i = 0; i <= this.storeOfferCards.length; i++) {
          if (this.storeOfferCards[i] != undefined) {
            if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
              this.totalPackagesArray.push(this.storeOfferCards[i])
            }
          }
        }
        this.OnlineApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
      } else if (tr_pack.tr_training_mode == '3') {
        for (let i = 0; i <= this.storeOfferCards.length; i++) {
          if (this.storeOfferCards[i] != undefined) {
            if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
              this.totalPackagesArray.push(this.storeOfferCards[i])
            }
          }
        }
        this.OnlineApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
      }
    }
    catch (error) {
      this.showToast();
      console.log(error);
      this.router.navigate(['../tabs/home']);
    }

  }

  async homeApi(tr_vendor_id, tr_package_id, HOC) {
    try {
      this.CommonDates = [];
      this.validatefor = null;
      var apiData = {
        "patientId": localStorage.getItem("patient_id"),
        "trainerId": tr_vendor_id,
        "packageId": tr_package_id,
      }

      this.service.postRequest1("getHomeDates", apiData).subscribe(async (res: any) => {
        if (res.status != 0) {
          for (let i = 0; i <= res.data.length; i++) {
            if (res.data[i] != undefined) {
              this.validatefor = res.data.length
              this.CommonDates.push({

                "tr_slot_duration": this.totalPackagesArray[0].tr_slot_duration,
                "tr_no_of_slots": this.totalPackagesArray[0].tr_no_of_slots,
                "tr_vendor_id": this.totalPackagesArray[0].tr_vendor_id,
                "tr_package_id": this.totalPackagesArray[0].tr_package_id,
                "tr_training_mode": this.totalPackagesArray[0].tr_training_mode,
                "is_vip": this.totalPackagesArray[0].is_vip,
                "tr_package_name": this.totalPackagesArray[0].tr_package_name,
                "tr_tainingcategory_id": this.totalPackagesArray[0].tr_tainingcategory_id,
                "tr_training_id": this.totalPackagesArray[0].tr_training_id,
                "tr_session": this.totalPackagesArray[0].tr_session,
                "tr_cost": this.totalPackagesArray[0].tr_cost,
                "tr_max_booking": this.totalPackagesArray[0].tr_max_booking,
                "tr_package_details": this.totalPackagesArray[0].tr_package_details,
                "tr_package_profile_path": this.totalPackagesArray[0].tr_package_profile_path,
                "tr_package_status": this.totalPackagesArray[0].tr_package_status,
                "tr_reschedule": this.totalPackagesArray[0].tr_reschedule,
                "dealId": this.totalPackagesArray[0].dealId,
                "dealName": this.totalPackagesArray[0].dealName,
                "dealOption": this.totalPackagesArray[0].dealOption,
                "dealValue": this.totalPackagesArray[0].dealValue,
                "programDays": this.totalPackagesArray[0].programDays,
                "featuresList": this.totalPackagesArray[0].featuresList,
                "dealserviceid": this.totalPackagesArray[0].dealserviceid,
                "defaultTrainingMode": this.totalPackagesArray[0].defaultTrainingMode,
                "ProgDays1": [],
                "ProgDays2": [],
                "appointmentScheduleId": res.data[i].appointmentScheduleId,
                "tr_from_time": res.data[i].tr_from_time,
                "tr_to_time": res.data[i].tr_to_time,
                "days": res.data[i].days,
                "dates": res.data[i].dates,
                "WeekDay": res.data[i].WeekDay,
                "month": res.data[i].month,
                "monthName": res.data[i].monthName,
                "year": res.data[i].year,
                "remainMode_isReche": res.data[i].remainMode_isReche,
                "isReschedule": res.data[i].isReschedule,
              });
            }
          }
          this.viewCtrl.dismiss({
            packdet: this.CommonDates,
            coh: HOC
          });
        }
      });
    }
    catch (error) {
      this.showToast();
      this.viewCtrl.dismiss(true);
      console.log(error);
      this.router.navigate(['../tabs/home']);
    }


  }

  OnlineApi(tr_vendor_id, tr_package_id, HOC) {
    try {
      this.CommonDates = [];
      this.validatefor = null;
      var apiData = {
        "patientId": localStorage.getItem("patient_id"),
        "trainerId": tr_vendor_id,
        "packageId": tr_package_id,
      }

      this.service.postRequest1("getOnlineDates", apiData).subscribe(async (res: any) => {
        if (res.status != 0) {
          for (let i = 0; i <= res.data.length; i++) {
            if (res.data[i] != undefined) {
              this.validatefor = res.data.length;
              this.CommonDates.push({

                "tr_slot_duration": this.totalPackagesArray[0].tr_slot_duration,
                "tr_no_of_slots": this.totalPackagesArray[0].tr_no_of_slots,
                "tr_vendor_id": this.totalPackagesArray[0].tr_vendor_id,
                "tr_package_id": this.totalPackagesArray[0].tr_package_id,
                "tr_training_mode": this.totalPackagesArray[0].tr_training_mode,
                "is_vip": this.totalPackagesArray[0].is_vip,
                "tr_package_name": this.totalPackagesArray[0].tr_package_name,
                "tr_tainingcategory_id": this.totalPackagesArray[0].tr_tainingcategory_id,
                "tr_training_id": this.totalPackagesArray[0].tr_training_id,
                "tr_session": this.totalPackagesArray[0].tr_session,
                "tr_cost": this.totalPackagesArray[0].tr_cost,
                "tr_max_booking": this.totalPackagesArray[0].tr_max_booking,
                "tr_package_details": this.totalPackagesArray[0].tr_package_details,
                "tr_package_profile_path": this.totalPackagesArray[0].tr_package_profile_path,
                "tr_package_status": this.totalPackagesArray[0].tr_package_status,
                "tr_reschedule": this.totalPackagesArray[0].tr_reschedule,
                "dealId": this.totalPackagesArray[0].dealId,
                "dealName": this.totalPackagesArray[0].dealName,
                "dealOption": this.totalPackagesArray[0].dealOption,
                "dealValue": this.totalPackagesArray[0].dealValue,
                "programDays": this.totalPackagesArray[0].programDays,
                "featuresList": this.totalPackagesArray[0].featuresList,
                "dealserviceid": this.totalPackagesArray[0].dealserviceid,
                "defaultTrainingMode": this.totalPackagesArray[0].defaultTrainingMode,
                "ProgDays1": [],
                "ProgDays2": [],
                "appointmentScheduleId": res.data[i].appointmentScheduleId,
                "tr_from_time": res.data[i].tr_from_time,
                "tr_to_time": res.data[i].tr_to_time,
                "days": res.data[i].days,
                "dates": res.data[i].dates,
                "WeekDay": res.data[i].WeekDay,
                "month": res.data[i].month,
                "monthName": res.data[i].monthName,
                "year": res.data[i].year,
                "remainMode_isReche": res.data[i].remainMode_isReche,
                "isReschedule": res.data[i].isReschedule,
              });


            }
          }
          this.viewCtrl.dismiss({
            packdet: this.CommonDates,
            coh: HOC
          });
        }
      })
    }
    catch (error) {
      this.showToast();
      this.viewCtrl.dismiss(true);
      console.log(error);
      this.router.navigate(['../tabs/home']);
    }
  }
  async showToast() {
    const toast = await this.toastController.create({
      message: "Please try agin later",
      duration: 2500,
      position: 'bottom',
      color: 'dark'
    });

    await toast.present();
  }
  getDiscountLabel(item) {
    if (item.deal_options === 'Percentage') {
        return `${item.deal_amount}%`;
    } else if (item.deal_options === 'Amount') {
        return `${item.deal_amount} KWD`;
    }
    return '';
}

getDiscountedPrice(item) {
    let discountedPrice = item.tr_cost;
    if (item.deal_options === 'Percentage') {
        discountedPrice = item.tr_cost * (1 - item.deal_amount / 100);
    } else if (item.deal_options === 'Amount') {
        discountedPrice = item.tr_cost - item.deal_amount;
    }
    let amount = this.formatAmount(discountedPrice)
    return amount;
}
getDiscountedtype(type){
  if(type.toLowerCase() == "percentage"){
    return "%"
  }else{
    return " KWD"
  }
}

formatAmount(number){
  const num = Number(number)
  const options = {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  };
  const formattedNumber = num.toLocaleString('en-US', options);
  const parts = formattedNumber.split('.');

  if (parts.length === 1) {
    return `${formattedNumber}.000`;
  } else {
    const decimalPart = parts[1].padEnd(3, '0');
    return `${parts[0]}.${decimalPart}`;
  }
}

}
